import * as helpers from '../helpers';

/**
 * Class represents Message component
 */
export default class StratisMessage {
    constructor(selector = '.message', options = null) {
        this.selector = selector;
        this.created = false;

        // Plugin options
        this.options = {
            closeBtnClass: 'message__close',
            closeBtnIcon: '<i class="fal fa-times"><span class="ghost">Fermer</span></i>',
            closeHelperClass: '-has-close-btn',
            obj: {
                class: '',
                modifier: '',
                title: '',
                description: '',
                html: null,
                closeBtn: false,
            },
        };

        this.create();
    }

    /**
     * Create
     */
    create() {
        if (!this.created) {
            // Start to initialize
            this.init();
        }
    }

    /**
     * Initialize plugin
     */
    init() {
        if (typeof this.selector === 'string') {
            this.created = true;

            const closeButtons = [...document.querySelectorAll(`.${this.options.closeBtnClass}`)];
            if (closeButtons) {
                closeButtons.forEach((btn) => {
                    this.btnEvents(btn, btn.parentNode);
                });
            }
        }
    }

    /**
     * Create close btn
     */
    createCloseBtn(message) {
        const closeBtn = document.createElement('button');
        helpers.addClass(closeBtn, this.options.closeBtnClass);
        helpers.addClass(message, this.options.closeHelperClass);
        closeBtn.innerHTML = this.options.closeBtnIcon;
        message.appendChild(closeBtn);
        this.btnEvents(closeBtn, message);
    }

    /**
     * Add events close btn
     */
    btnEvents(closeBtn, message) {
        closeBtn.addEventListener('click', () => {
            closeBtn.parentNode.parentNode.removeChild(message);
        });
    }

    /**
     * Create message
     */
    static createMessage(obj) {
        const messageTitle = document.createElement('h2');
        const messageDescription = document.createElement('p');

        if (obj.title) {
            messageTitle.innerHTML = obj.title;
        }

        if (obj.description) {
            messageDescription.innerHTML = obj.description;
        }

        const message = document.createElement('div');

        if (obj.class) {
            helpers.addClass(message, obj.class);
        }

        if (obj.modifier) {
            helpers.addClass(message, obj.modifier);
        }

        message.appendChild(messageTitle);
        message.appendChild(messageDescription);

        if (obj.html) {
            message.appendChild(obj.html);
        }

        if (obj.closeBtn) {
            const newMessage = new StratisMessage();
            newMessage.createCloseBtn(message);
        }

        return message;
    }
}
